import { IHeaderTheme, ISuiteHeaderStyles } from './SuiteHeader.types';
import { ScreenWidthMinMedium, ScreenWidthMinXLarge } from '@fluentui/react';
import {
  activeBackgroundColor,
  defaultBackgroundColor,
  defaultForegroundColor,
  hoverBackgroundColor,
  hoverForegroundColor,
  msGridUnit,
  tenantBrandingHeight
} from './constants';

export const getHeaderStyles = (theme?: IHeaderTheme): ISuiteHeaderStyles => {
  const headerStyles: ISuiteHeaderStyles = {
    root: {
      height: `${msGridUnit * 6}px`,
      width: '100%',
      display: 'flex',
      flex: '0 0 auto',
      backgroundColor: theme?.backgroundColor || defaultBackgroundColor,
      borderBottom: '1px solid #eaeaea',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 1000,
      position: 'relative'
    },
    leftRegion: {
      minWidth: `${msGridUnit * 5}px`,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      selectors: {
        ['#O365_MainLink_NavMenu:focus']: {
          border: '1px solid #000000'
        }
      }
    },
    centerRegion: {
      flex: '1 0 auto',
      display: 'flex',
      justifyContent: 'space-between'
    },
    rightRegion: {
      minWidth: `${msGridUnit * 5}px`,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    leftButtonGroup: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    divider: {
      width: '0',
      borderLeft: `1px solid ${theme?.foregroundColor || defaultForegroundColor}`,
      height: `${tenantBrandingHeight}px`,
      marginRight: '8px',
      display: 'flex',
      selectors: {
        [`@media (max-width: ${ScreenWidthMinMedium}px)`]: {
          display: 'none'
        }
      }
    },
    appBranding: {
      color: theme?.foregroundColor || defaultForegroundColor,
      textDecoration: 'none',
      padding: '0 2px',
      height: '48px',
      alignItems: 'center',
      display: 'flex',
      fontWeight: 600,
      selectors: {
        [`@media (max-width: ${ScreenWidthMinMedium}px)`]: {
          display: 'none'
        },
        '& > h1': {
          fontWeight: 600,
          margin: 0,
          lineHeight: 'normal'
        },
        ':hover': {
          color: hoverForegroundColor,
          backgroundColor: hoverBackgroundColor
        },
        ':active': {
          color: hoverForegroundColor,
          backgroundColor: activeBackgroundColor
        },
        ':focus-visible': {
          outline: '#605e5c solid 1px',
          outlineOffset: '-2px'
        }
      }
    },
    appSwitcher: {
      ' i': {
        lineHeight: 'inherit'
      }
    },
    centerSearchGroup: {
      flex: 1,
      display: 'flex'
    },
    rightButtonGroup: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    buttonGroupExpanded: {
      display: 'flex',
      selectors: {
        [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
          display: 'none'
        }
      }
    },
    buttonGroupCollapsed: {
      display: 'none',
      selectors: {
        [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
          display: 'flex'
        }
      }
    },

    waffle: {
      selectors: {
        '& .ms-Button-flexContainer': {
          display: 'flex',
          alignItems: 'center'
        }
      }
    }
  };

  return headerStyles;
};
